import { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import MainTableLayout from "components/wrappers/MainTableLayout";
import ArrivalListTable from "components/ArrivalListTable";
import GuestsTableModal from "components/GuestsTableModal";
import Button from "components/general/Button";

import { useGetArrivalExcelDataMutation } from "apis/services/arrival";
import ExportDataModal from "components/modals/ExportData";
import downloadFromBlob from "utils/downloadFromBlob";

export default function Home() {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [searchParams] = useSearchParams();
  const [getArrivalExcellData] = useGetArrivalExcelDataMutation();
  const [isExportArrivalExcelDataModalVisible, setIsExportArrivalExcelDataModalVisible] = useState(false);

  const searchTerm = searchParams.get("search") || "";
  const startDateParam = searchParams.get("startDate") || undefined;
  const endDateParam = searchParams.get("endDate") || undefined;
  

  const navigate = useNavigate();
  const handleAddNewArrivalNavigation = () => {
    navigate("/Dashboard/add-new-arrival", {
      state: { headerTitle: "Add New Arrival" },
    });
  };

  // const exportArrivalData = () => {
  //   getArrivalExcellData()
  //     .unwrap()
  //     .then((res) => {})
  //     .catch((err) => console.log(err));
  // };
  return (
    <>
      <MainTableLayout
        title=""
        hideSearch={false}
        mainBtnText="Add New Arrival"
        mainBtnOnClick={handleAddNewArrivalNavigation}
        exportBtnText="Export"
        exportBtnOnClick={() => {
          setIsExportArrivalExcelDataModalVisible(true);
        }}
      >
        <ExportDataModal
          onCancel={()=>{}}
          onConfirm={(format)=>{
            getArrivalExcellData({ 
              file_type: format,
              search: searchTerm,
              arrival_date_after: startDateParam,
              arrival_date_before: endDateParam,
             }).unwrap().then((res) => {
              downloadFromBlob(res, `Arrival.${format}`)
            });
          }}
          isVisible={isExportArrivalExcelDataModalVisible}
          setIsVisible={setIsExportArrivalExcelDataModalVisible}
          titleLabel="Arrivals"
        />
        <ArrivalListTable setIsGuestsModalVisible={setIsModalVisible} />
      </MainTableLayout>
      <GuestsTableModal
        isVisible={isModalVisible}
        setIsVisible={setIsModalVisible}
      />
    </>
  );
}
